import * as React from 'react';
import Svg, {
  SvgProps,
  Path,
  Defs,
  LinearGradient,
  Stop,
} from 'react-native-svg';

const SvgComponent = (props: SvgProps) => {
  const gradientId = React.useMemo(
    () => `grad-${Math.random().toString(36).substring(2, 9)}`,
    [],
  );

  return (
    <Svg
      width={73}
      height={73}
      viewBox="0 0 73 73"
      {...props}
      fill="none"
      stroke="none">
      <Path
        fill={props.fill || '#070A7A'}
        d="M35.72 68.612c17.795 0 32.22-14.425 32.22-32.22 0-17.795-14.425-32.22-32.22-32.22-17.794 0-32.22 14.425-32.22 32.22 0 17.795 14.426 32.22 32.22 32.22Z"
      />
      <Path
        stroke={`url(#${gradientId})`}
        strokeMiterlimit={10}
        strokeWidth={4}
        d="M36.04 70.39c-18.75 0-34-15.25-34-34s15.25-34 34-34 34 15.25 34 34-15.25 34-34 34Z"
      />
      <Path
        fill={props.stroke || '#fff'}
        d="M17.67 30.25h-1.33v12.29h1.33V30.25ZM30.14 30.25h-1.33v12.29h1.33V30.25ZM33.26 31.82h-1.33v9.13h1.33v-9.13ZM45.74 30.25h-1.33v12.29h1.33V30.25ZM48.86 31.82h-1.33v9.13h1.33v-9.13ZM14.55 33.98h-1.33v4.82h1.33v-4.82ZM58.22 33.98h-1.33v4.82h1.33v-4.82ZM20.791 27.84h-1.33v17.1h1.33v-17.1ZM27.02 27.84h-1.33v17.1h1.33v-17.1ZM23.9 25.852h-1.33v21.09h1.33v-21.09ZM36.38 27.84h-1.33v17.1h1.33v-17.1ZM42.621 27.84h-1.33v17.1h1.33v-17.1ZM55.1 30.25h-1.33v12.29h1.33V30.25ZM51.98 27.84h-1.33v17.1h1.33v-17.1ZM39.5 25.852h-1.33v21.09h1.33v-21.09Z"
      />
      <Defs>
        <LinearGradient
          id={gradientId}
          x1={20.82}
          x2={51.25}
          y1={3.771}
          y2={69.021}
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#87F5FF" />
          <Stop offset={0.07} stopColor="#7CEEFB" />
          <Stop offset={0.18} stopColor="#61DDF2" />
          <Stop offset={0.33} stopColor="#35C1E4" />
          <Stop offset={0.38} stopColor="#27B9E0" />
          <Stop offset={0.46} stopColor="#27ADE1" />
          <Stop offset={0.61} stopColor="#2890E6" />
          <Stop offset={0.8} stopColor="#2A5FED" />
          <Stop offset={1} stopColor="#2D27F6" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
};

export default SvgComponent;
